function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "Layer_x0020_1"
}, /*#__PURE__*/React.createElement("metadata", {
  id: "CorelCorpID_0Corel-Layer"
}), /*#__PURE__*/React.createElement("g", {
  id: "_225698728"
}, /*#__PURE__*/React.createElement("path", {
  id: "_225699184",
  fill: "current",
  stroke: "current",
  strokeWidth: 2,
  d: "M590.614 1353.36c46.1941,0 88.0701,18.7606 118.335,48.9993 30.2599,30.2374 49.037,72.0804 49.037,118.244 0,46.1563 -18.7772,88.0016 -49.037,118.24 -30.2634,30.2386 -72.1406,49.0016 -118.335,49.0016 -46.1941,0 -87.9473,-18.763 -118.208,-49.0016 -30.3851,-30.2386 -49.0359,-72.0839 -49.0359,-118.24 0,-46.1634 18.6496,-88.0052 49.0359,-118.244 30.261,-30.2386 72.0142,-48.9969 118.208,-48.9969l0 -0.00236221z"
}), /*#__PURE__*/React.createElement("path", {
  id: "_225699256",
  fill: "current",
  stroke: "current",
  strokeWidth: 2,
  d: "M1326.91 1353.36c46.1953,0 88.0678,18.7606 118.332,48.9993 30.2658,30.2374 49.0323,72.0804 49.0323,118.244 0,46.1563 -18.7677,88.0016 -49.0323,118.24 -30.2646,30.2386 -72.1371,49.0016 -118.332,49.0016 -46.1953,0 -88.069,-18.763 -118.332,-49.0016 -30.2599,-30.2386 -49.0335,-72.0839 -49.0335,-118.24 0,-46.1634 18.7713,-88.0052 49.0335,-118.244 30.2658,-30.2386 72.1359,-48.9969 118.332,-48.9969l0 -0.00236221z"
}), /*#__PURE__*/React.createElement("path", {
  id: "_225699424",
  fill: "current",
  stroke: "current",
  strokeWidth: 2,
  d: "M824.932 727.96l0 -39.6213c0,-61.3418 35.5748,-100.714 81.0296,-117.995 16.7988,-6.29528 34.9536,-9.50316 52.8662,-9.50316 17.9055,0 35.9422,3.20788 52.7398,9.50316 45.5788,17.2807 81.0308,56.654 81.0308,117.996l0 39.6201 -267.666 0z"
}), /*#__PURE__*/React.createElement("path", {
  id: "_225698944",
  fill: "current",
  stroke: "current",
  strokeWidth: 2,
  d: "M992.298 393.598c0,-18.5138 -15.0673,-33.4477 -33.4701,-33.4477 -18.5244,0 -33.4772,14.9339 -33.4772,33.4477l0 103.432c0,18.5138 14.9528,33.4488 33.4772,33.4488 18.404,0 33.4701,-14.9351 33.4701,-33.4488l0 -103.432z"
}), /*#__PURE__*/React.createElement("path", {
  id: "_225698824",
  fill: "current",
  stroke: "current",
  strokeWidth: 2,
  d: "M1147.44 454.323c9.1441,-15.9213 3.7063,-36.2859 -12.3473,-45.4193 -15.9343,-9.13465 -36.3166,-3.70394 -45.4595,12.2185l-51.7524 89.6079c-9.14292,16.0441 -3.70985,36.2859 12.2291,45.5445 16.0547,9.13465 36.4335,3.57874 45.5741,-12.3437l51.7559 -89.6079z"
}), /*#__PURE__*/React.createElement("path", {
  id: "_225698776",
  fill: "current",
  stroke: "current",
  strokeWidth: 2,
  d: "M827.898 421.122c-9.13938,-15.9225 -29.5217,-21.3532 -45.4607,-12.2185 -15.9331,9.13347 -21.4914,29.4992 -12.2232,45.4193l51.7524 89.6068c9.13938,15.9225 29.5193,21.4795 45.4548,12.3449 15.939,-9.25985 21.4914,-29.4992 12.228,-45.5445l-51.7512 -89.6079z"
}), /*#__PURE__*/React.createElement("path", {
  id: "_225698200",
  fill: "current",
  stroke: "current",
  strokeWidth: 2,
  d: "M1164.73 1143.17c-16.4232,0 -31.3713,-6.79134 -42.2433,-17.524 -10.8662,-10.8638 -17.5382,-25.8024 -17.5382,-42.2126l0 -119.355c0,-16.415 6.67205,-31.3477 17.5382,-42.2103 10.8721,-10.7398 25.8201,-17.5252 42.2433,-17.5252l169.719 -0.0011811c0,-5.43308 191.822,198.469 231.719,238.83l-401.438 -0.0011811zm-331.774 -13.8236l-150.566 0 0 150.457 -66.9485 0 0 -150.457 -150.571 0 0 -66.8977 150.571 0 0 -150.457 66.9485 0 0 150.457 150.566 0 0 66.8977zm863.774 26.537c-23.8347,-11.9728 -51.88,-26.0433 -79.7965,-51.2233 -54.717,-49.6193 -329.667,-343.249 -356.967,-343.249l-886.869 0c-32.2394,0 -61.513,13.2083 -82.7599,34.4362 -21.1205,21.1051 -34.3382,50.4792 -34.3382,82.6973l0 535.054c0,32.2122 13.2177,61.4646 34.3382,82.5733 21.2469,21.2256 50.5205,34.4327 82.7599,34.4327l17.0457 0c-0.122835,-3.33071 -0.248032,-6.6626 -0.248032,-9.9945 0,-53.3245 20.9988,-104.173 58.7941,-141.82 37.7977,-37.7658 88.5638,-58.7493 141.925,-58.7493 53.4839,0 104.251,20.9835 142.047,58.7493 37.8,37.6465 58.793,88.4953 58.793,141.82 0,3.33189 -0.11811,6.66378 -0.242126,9.9945l335.106 0c-0.122835,-3.33071 -0.246851,-6.6626 -0.246851,-9.9945 0,-53.3245 21.1252,-104.173 58.9217,-141.82 37.6725,-37.7658 88.565,-58.7493 141.921,-58.7493 53.3599,0 104.249,20.9835 141.925,58.7493 37.7965,37.6465 58.9182,88.4953 58.9182,141.82 0,3.33189 -0.124016,6.66378 -0.246851,9.9945l100.547 0c30.5079,0 62.1296,-12.5894 87.6969,-32.2122 25.4445,-19.624 45.5788,-46.9052 53.3587,-76.5225 15.7323,-60.3497 22.8095,-104.774 22.8862,-138.458 0.180709,-79.7812 -38.9055,-99.3225 -95.269,-127.528z"
})));

var _ref3 = /*#__PURE__*/React.createElement("rect", {
  fill: "current",
  stroke: "current",
  strokeWidth: 2,
  width: 2048,
  height: 2048
});

var SvgAmbulance1 = function SvgAmbulance1(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlSpace: "preserve",
    width: "2048px",
    height: "2048px",
    style: {
      shapeRendering: "geometricPrecision",
      textRendering: "geometricPrecision",
      imageRendering: "optimizeQuality",
      fillRule: "evenodd",
      clipRule: "evenodd"
    },
    viewBox: "0 0 2048 2048",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgAmbulance1, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/Ambulance1.8bcc5727.svg";
export { ForwardRef as ReactComponent };